import React from 'react';
import { Show, TextField, DateField } from 'react-admin';
import { GridShowLayout, Grid } from '../../components/wrapper';
import { LinkField, AmountField } from '../../components/fields';
import UnmatchedPaymentShowActions from './UnmatchedPaymentShowActions';

const UnmatchedPaymentShow = props => (
	<Show {...props} actions={<UnmatchedPaymentShowActions />}>
		<GridShowLayout>
			<Grid container>
				<Grid item xs>
					<TextField source="id" />
					<DateField source="creationDateTime" showTime />
					<TextField source="unmatchedPaymentStatus" />
					<DateField source="resolveDateTime" showTime />
					<LinkField source="resolver" />
					<TextField source="description" />
					<LinkField source="paymentTransactionData.owner" />
					<DateField source="paymentTransactionData.date" showTime />
					<AmountField source="paymentTransactionData.amount" />
					<TextField source="paymentTransactionData.transactionType" />
				</Grid>
				<Grid item xs>
					<TextField source="paymentTransactionData.oldStatus" />
					<TextField source="paymentTransactionData.newStatus" />
					<TextField source="paymentTransactionData.externalPaymentId" />
					<TextField source="paymentTransactionData.externalTransactionId" />
					<TextField source="paymentTransactionData.mcc" />
					<TextField source="paymentTransactionData.paymentMethodName" />
					<TextField source="paymentTransactionData.paymentContext" />
					<TextField source="paymentTransactionData.subject" />
					<LinkField
						source="paymentTransactionData.publicPaymentInstrumentId"
						resource={'paymentInstruments'}
					/>
					<LinkField source="paymentTransactionData.publicTransactionId" />
				</Grid>
			</Grid>
		</GridShowLayout>
	</Show>
);

export default UnmatchedPaymentShow;
